<div class="container">
<ol *ngIf="downloads | async as files" class="list-group list-group-numbered p-4">
  <li *ngFor="let file of files" class="list-group-item d-flex justify-content-between align-items-start">
    <div class="ms-2 me-auto">
      <div class="fw-bold">{{file.title}}</div>
      {{file.description}}
    </div>
    <a class="btn btn-primary" target="_blank" [href]="'/assets/files/'+ file.file">Download</a>
  </li>
</ol>
</div>
